import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import createaction from "../../context/action/customer/createaction";
import Customerlist from "./customerlist";

const Customer = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
        useContext(GlobalContext);

    const [customer_name,setcustomer_name]=useState('');
    const [customer_phone,setcustomer_phone]=useState('');
    const [customer_address,setcustomer_address]=useState('');
    const [customer_init_loan,setcustomer_init_loan]=useState(0);
    const [customer_date,setcustomer_date]=useState('');

    const [error,seterror]=useState(false);
    const [error1,seterror1]=useState(false);
    const [error2,seterror2]=useState(false);
    const [error3,seterror3]=useState(false);
    return (
        <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                    <h1 className="text-2xl font-bold text-slate-800">کڕیار</h1>
                    <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی کڕیارەکان</p>
                </div>
            </div>

            {/* Add New Customer Form */}
            <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 items-end">
                <div className="w-full">
                    <label
                    className={
                        error
                        ? "block text-sm font-medium text-red-500 mb-1 text-right"
                        : "block text-sm font-medium text-slate-500 mb-1 text-right"
                    }
                    htmlFor="customer_name"
                    >
                        ناوی کڕیار
                    </label>
                    <input
                    className={
                        error
                        ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                        : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                    }
                    id="customer_name"
                    type="text"
                    placeholder=""
                    onClick={(val)=>{val.target.select()}}
                    value={customer_name}
                    onChange={(val) => setcustomer_name(val.target.value)}
                    onFocus={() => seterror(false)}
                    />
                </div>
                <div className="w-full">
                    <label
                    className={
                        error1
                        ? "block text-sm font-medium text-red-500 mb-1 text-right"
                        : "block text-sm font-medium text-slate-500 mb-1 text-right"
                    }
                    htmlFor="customer_address"
                    >
                    ناونیشان
                    </label>
                    <input
                    className={
                        error1
                        ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                        : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                    }
                    id="customer_address"
                    type="text"
                    placeholder=""
                    onClick={(val)=>{val.target.select()}}
                    value={customer_address}
                    onChange={(val) => setcustomer_address(val.target.value)}
                    onFocus={() => seterror1(false)}
                    />
                </div>
                <div className="w-full">
                    <label
                    className={
                        error2
                        ? "block text-sm font-medium text-red-500 mb-1 text-right"
                        : "block text-sm font-medium text-slate-500 mb-1 text-right"
                    }
                    htmlFor="customer_phone"
                    >
                    ژمارەی تەلەفۆن
                    </label>
                    <input
                    className={
                        error2
                        ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                        : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                    }
                    id="customer_phone"
                    type="text"
                    placeholder=""
                    onClick={(val)=>{val.target.select()}}
                    value={customer_phone}
                    onChange={(val) => setcustomer_phone(val.target.value)}
                    onFocus={() => seterror2(false)}
                    />
                </div>
                <div className="w-full">
                    <label
                    className={
                        error3
                        ? "block text-sm font-medium text-red-500 mb-1 text-right"
                        : "block text-sm font-medium text-slate-500 mb-1 text-right"
                    }
                    htmlFor="customer_init_loan"
                    >
                    قەرزی بنچینەی
                    </label>
                    <input
                    className={
                        error3
                        ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-500"
                        : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    }
                    id="customer_init_loan"
                    type="number"
                    placeholder=""
                    onClick={(val)=>{val.target.select()}}
                    value={customer_init_loan}
                    onChange={(val) => setcustomer_init_loan(val.target.value)}
                    onFocus={() => seterror3(false)}
                    />
                </div>
                {/* <div className="w-full">
                    <label
                    className={
                        "block text-sm font-medium text-slate-500 mb-1 text-right"
                    }
                    htmlFor="customer_init_loannn"
                    >
                    بەروار
                    </label>
                    <input
                    className={
                        "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    }
                    id="customer_init_loannn"
                    type="date"
                    placeholder=""
                    onClick={(val)=>{val.target.select()}}
                    value={customer_date}
                    onChange={(val) => setcustomer_date(val.target.value)}
                    />
                </div> */}
                <div className="w-full">
                    <button
                    className="h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                    onClick={() => {
                        if (customer_name == "" || !customer_name) {
                        seterror(true);
                        return false;
                        }
                        if (customer_address == "" || !customer_address) {
                        seterror1(true);
                        return false;
                        }
                        if (customer_phone == "" || !customer_phone) {
                        seterror2(true);
                        return false;
                        }
                        if (customer_init_loan < 0) {
                        seterror3(true);
                        return false;
                        }
                        createaction(customer_name,customer_address,customer_phone,customer_init_loan,initState.token.user_id)(recaller)(setrecaller)(initDispatch)(clear);
                        // createaction(customer_name,customer_address,customer_phone,customer_init_loan,customer_date,initState.token.user_id)(recaller)(setrecaller)(initDispatch)(clear);
                    }}
                    >
                    زیادکردن
                    </button>
                </div>
            </div>
            </div>

            {/* Customer List Section */}
            <Customerlist />
        </div>
    )
}

export default Customer